import { FC } from 'react';
import { Label } from '@bluebeam/react-skyline-label';

type LabelProps = {
  text: string;
};

export const FormLabel: FC<LabelProps> = ({ text }) => <Label className="text-gray">{text}</Label>;
